export default __webpack_public_path__ + "static/media/check_circle.d644464e.svg";